<svg [attr.height]="height" [attr.width]="width" xmlns="http://www.w3.org/2000/svg">
  <circle [attr.fill]="fillColor" cx="5" cy="5" r="5"/>
</svg>